import CertificadoJavaJdbcFrente from "../assets/Images/certificades/Certificado Curso JAVA e JDBC Alura frente 1024_1.jpg";
import CertificadoJavaJdbcVerso from '../assets/Images/certificades/Certificado Curso JAVA e JDBC Alura verso 1024_1.jpg';
import CertificadoCursoJavaJpaAluraFrente from "../assets/Images/certificades/Certificado Curso JAVA e JPA Alura ( frente ).jpg"
import CertificadoCursoJavaJpaAluraCerso from "../assets/Images/certificades/Certificado Curso JAVA e JPA Alura ( verso ).jpg"
import CertificadoCursoJavaUtilAluraFrente from "../assets/Images/certificades/Certificado Curso Java.UTIL Alura  (frente).jpg"
import CertificadoCursoJavaUtilAluraVerso from "../assets/Images/certificades/Certificado Curso Java.UTIL Alura  (Verso).jpg"
import CertificadoCursoJavascript2AluraFrente from "../assets/Images/certificades/Certificado Curso JavaScript 2 Alura ( frente ).jpg"
import CertificadoCursoJavascript2AluraVerso from "../assets/Images/certificades/Certificado Curso JavaScript 2 Alura ( verso ).jpg"
import CertificadoCursoJavascript3AluraFrente from "../assets/Images/certificades/Certificado Curso JavaScript 3 Alura ( frente ).jpg"
import CertificadoCursoJavascript3AluraVerso from "../assets/Images/certificades/Certificado Curso JavaScript 3 Alura ( verso ).jpg"
import CertificadoCursoJavascriptAluraFrente from "../assets/Images/certificades/Certificado Curso JavaScript Alura ( frente ).jpg"
import CertificadoCursoJavascriptAluraVerso from "../assets/Images/certificades/Certificado Curso JavaScript Alura ( verso ).jpg"
import CertificadoCursoMetodosAgeisAluraFrente from "../assets/Images/certificades/Certificado Métodos Ágeis Alura ( frente ).jpg"
import CertificadoCursoMetodosAgeisAluraVerso from "../assets/Images/certificades/Certificado Métodos Ágeis Alura ( verso ).jpg"
import CertificadoCursoScrumAluraFrente from "../assets/Images/certificades/Certificado Scrum Alura ( frente ).jpg"
import CertificadoCursoScrumAluraVerso from "../assets/Images/certificades/Certificado Scrum Alura ( verso ).jpg"
import CertificadoCursoVueJs2AluraFrente from "../assets/Images/certificades/Certificado VUE.JS  2 Alura ( frente ).jpg"
import CertificadoCursoVueJs2AluraVerso from "../assets/Images/certificades/Certificado VUE.JS  2 Alura ( verso ).jpg"
import CertificadoCursoVueJsAluraFrente from "../assets/Images/certificades/Certificado VUE.JS Alura ( frente ).jpg"
import CertificadoCursoVueJsAluraVerso from "../assets/Images/certificades/Certificado VUE.JS Alura ( verso ).jpg"
import CertificadoCursoWebPackAluraFrente from "../assets/Images/certificades/Certificado WEBPACK Alura ( frente ).jpg"
import CertificadoCursoWebPackAluraVerso from "../assets/Images/certificades/Certificado WEBPACK Alura ( verso ).jpg"
import CertificadoFullStackReactRouter6NET6EFCoreUdemy  from "../assets/Images/certificades/Certificado Full Stack React NET6 udemy.jpg"
import CertificadoGraduacao from "../assets/Images/certificades/CERTIFICADO GRADUAÇÃO 1.jpeg"
import CertificadoPSM1 from "../assets/Images/certificades/Certificado PSM1 Scrum.Org.png"
import CertificadoReactJsRestApiUdemy from "../assets/Images/certificades/Certificado React Js consumindo Rest Api RestFul em ASP.NET Core .NET6 umdey.jpg"
import ScrumFundationProfessionalCertProf2019 from "../assets/Images/certificades/Certificao Scrum certprof 2019.jpg"
import ScrumFundationProfessionalCertProf2023 from "../assets/Images/certificades/Certificate certiprof 2023.jpg"
import ScrumFundationProfessionalAdaptIdeas from "../assets/Images/certificades/ScrumMasterProfessionalAdaptIdeas.png"
import FormacaoJavaCaelum from "../assets/Images/certificades/Certificado Caelum Formacao Java.jpeg"
import JavaOrientacaoObjeto from "../assets/Images/certificades/Certificado Caelum Java Orientacao A Objetos.jpeg"
import JavaDesenvolvimentoWeb from "../assets/Images/certificades/Certificado Caelum Java Desenvolvimento Web.jpeg"
import MicrosoftExcelEazycomp from "../assets/Images/certificades/Microsoft Excel Eazycomp.jpeg"
import MicrosoftAccessEazycomp from "../assets/Images/certificades/Microsoft Access EazyComp.jpeg"
import MicrosoftInternetOutllokEazycomp from "../assets/Images/certificades/Microsoft Internet  - Outlook EazyComp.jpeg"
import MarketingPessoal from "../assets/Images/certificades/T&D Marketing Pessoal .jpeg"
import LoginApiGoogle from "../assets/Images/certificades/LoginApi-reactjs+AspNet.CORE.jpg"
import AspNetCoreMvcSqlServer from "../assets/Images/certificades/Certificado-AspnetCore-Identity+mvc-e-web.jpg"
import CertificadoJiraFundamental from "../assets/Images/certificades/CertificadoJira.png"
import CertificadoAluraUx from "../assets/Images/certificades/CertificadoAluraCursodeUX(1) _page-0001.jpg"
import MBAFrente from "../assets/Images/certificades/MBA-arquitetura-full-cycle.jpg"
import MBAVerso from "../assets/Images/certificades/MBA-arquitetura-full-cycle-verso.jpg"

export const Certificades = [
    {
        id:31,
        name:"MBA Arquitetura Full Cycle",
        date:"01 de Junho de 2025",
        workload: undefined,
        school: "Universidade Nove de Julho",
        imgSrcFront:CertificadoGraduacao,
        imgSrcBack: undefined
    },
    {
        id:30,
        name:"Bacharel em Ciências da Computação",
        date:"08 de Janeiro de 2014",
        workload: 600,
        school: "Full Cycle Tech",
        imgSrcFront:MBAFrente,
        imgSrcBack:MBAVerso
    },
    {
        id:29,
        name:"Certificado PSM1",
        date:"06 de Maio de 2023",
        workload: undefined,
        school: "Scrum.Org",
        imgSrcFront:CertificadoPSM1,
        imgSrcBack: undefined
    },
    {
        id:28,
        name:"Formação Java Caelum",
        date:"28 de Agosto de 2015",
        workload: 100,
        school: "Caelum",
        imgSrcFront: FormacaoJavaCaelum,
        imgSrcBack: undefined
    },
    {
        id:27,
        name:"Java Desenvolvimento Web",
        date:"21 de Agosto de 2015",
        workload: 40,
        school: "Caelum",
        imgSrcFront:JavaDesenvolvimentoWeb,
        imgSrcBack: undefined
    },
    {
        id:26,
        name:"Java Orientação a Objetos",
        date:"07 de Agosto de 2015",
        workload: 40,
        school: "Caelum",
        imgSrcFront:JavaOrientacaoObjeto,
        imgSrcBack: undefined
    },
    {
        id:25,
        name:"Certificação Jira Fundamentals Badge",
        date:"28 de Setembro de 2023",
        workload: undefined,
        school: "Atlassian University Badge",
        imgSrcFront:CertificadoJiraFundamental,
        imgSrcBack: undefined
    },
    {
        id:24,
        name:"Scrum - Professional Scrum Master - Scrum.ORG",
        date:"25 de Julho de 2023",
        workload: 16,
        school: "Adapt Ideas",
        imgSrcFront:ScrumFundationProfessionalAdaptIdeas,
        imgSrcBack: undefined
    },
    {
        id:23,
        name:"Scrum - Scrum Fundation Professional Certificate",
        date:"06 de Abril de 2019",
        workload: undefined,
        school: "CertProf",
        imgSrcFront:ScrumFundationProfessionalCertProf2019,
        imgSrcBack: undefined
    },
    {
        id:22,
        name:"Scrum - Scrum Fundation Professional Certificate",
        date:"25 de Julho de 2023",
        workload: undefined,
        school: "CertProf",
        imgSrcFront:ScrumFundationProfessionalCertProf2023,
        imgSrcBack: undefined
    },
    {
        id:21,
        name:"Asp.NET Core Identity + MVC e WebApi + Sql Server + EF Core",
        date:"13 de Setembro de 2023",
        workload: undefined,
        school: "Udemy",
        imgSrcFront:AspNetCoreMvcSqlServer,
        imgSrcBack: undefined
    },
    {
        id:20,
        name:"Certificado Ultimate Authentication with GoogleApi + ReactJs + AspNet.CORE",
        date:"31 de Agosto de 2023",
        workload: 3,
        school: "Udemy",
        imgSrcFront: LoginApiGoogle,
        imgSrcBack: undefined
    },
    {
        id:19,
        name:"Certificado Full Stack ReactJs + React Router 6 + .NET6 + EF Core",
        date:"12 de Agosto de 2023",
        workload: 16.5,
        school: "Udemy",
        imgSrcFront: CertificadoFullStackReactRouter6NET6EFCoreUdemy,
        imgSrcBack: undefined
    },
    {
        id:18,
        name:"Certificado ReactJs + Rest API ASP.NET Core",
        date:"02 de Maio de 2022",
        workload: 5,
        school: "Udemy",
        imgSrcFront:CertificadoReactJsRestApiUdemy,
        imgSrcBack: undefined
    },
    {
        id:17,
        name:"Certificado Javascript Programando para Linguagem Web",
        date:"06 de Outubro de 2017",
        workload: 20,
        school: "Alura",
        imgSrcFront:CertificadoCursoJavascript3AluraFrente,
        imgSrcBack:CertificadoCursoJavascript3AluraVerso
    },
    {
        id:16,
        name:"Certificado VUE.JS  Contruindo Single Page Aplications Part 1",
        date:"07 de Dezembro de 2017",
        workload: 16,
        school: "Alura",
        imgSrcFront:CertificadoCursoVueJsAluraFrente,
        imgSrcBack:CertificadoCursoVueJsAluraVerso
    },
    {
        id:15,
        name:"Certificado VUE.JS Contruindo Single Page Aplications",
        date:"07 de Dezembro de 2017",
        workload: 16,
        school: "Alura",
        imgSrcFront:CertificadoCursoVueJs2AluraFrente,
        imgSrcBack:CertificadoCursoVueJs2AluraVerso
    },
    {
        id:14,
        name:"Certificado UX Design",
        date:"07 de Dezembro de 2017",
        workload: 40,
        school: "Alura",
        imgSrcFront:CertificadoAluraUx,
        imgSrcBack:undefined
    },
    {
        id:13,
        name:"Certificado Java e Java.UTIL",
        date:"24 de Maio de 2018",
        workload: 12,
        school: "Alura",
        imgSrcFront:CertificadoCursoJavaUtilAluraFrente,
        imgSrcBack:CertificadoCursoJavaUtilAluraVerso
    },
    {
        id:12,
        name:"Certificado Métodos Ágeis",
        date:"05 de Abril de 2019",
        workload: 12,
        school: "Alura",
        imgSrcFront:CertificadoCursoMetodosAgeisAluraFrente,
        imgSrcBack:CertificadoCursoMetodosAgeisAluraVerso
    },
    {
        id:11,
        name:"Certificado Scrum",
        date:"09 de Abril de 2019",
        workload: 10,
        school: "Alura",
        imgSrcFront:CertificadoCursoScrumAluraFrente,
        imgSrcBack:CertificadoCursoScrumAluraVerso
    },
    {
        id:10,
        name:"Certificado Java e Jdbc",
        date:"11 de Abril de 2019",
        workload: 8,
        school: "Alura",
        imgSrcFront:CertificadoJavaJdbcFrente,
        imgSrcBack:CertificadoJavaJdbcVerso
    },
    {
        id:9,
        name:"Certificado Java e JPA",
        date:"29 de Abril de 2019",
        workload: 17,
        school: "Alura",
        imgSrcFront:CertificadoCursoJavaJpaAluraFrente,
        imgSrcBack:CertificadoCursoJavaJpaAluraCerso
    },
    {
        id:8,
        name:"Certificado Javascript Browser e Design Patterns",
        date:"21 de Setembro de 2019",
        workload: 12,
        school: "Alura",
        imgSrcFront:CertificadoCursoJavascript2AluraFrente,
        imgSrcBack:CertificadoCursoJavascript2AluraVerso
    },
    {
        id:7,
        name:"Certificado Javascript MVC, Prox e Factory Pattern",
        date:"22 de Setembro de 2019",
        workload: 12,
        school: "Alura",
        imgSrcFront:CertificadoCursoJavascriptAluraFrente,
        imgSrcBack:CertificadoCursoJavascriptAluraVerso
    },
    {
        id:6,
        name:"Certificado WEBPACK",
        date:"23 de Setembro de 2019",
        workload: 8,
        school: "Alura",
        imgSrcFront:CertificadoCursoWebPackAluraFrente,
        imgSrcBack:CertificadoCursoWebPackAluraVerso
    },
    {
        id:5,
        name:"Microsoft Access EazyComp",
        date:"09 de Agosto de 2004",
        workload: 20,
        school: "EazyComp",
        imgSrcFront:MicrosoftAccessEazycomp,
        imgSrcBack: undefined
    },
    {
        id:4,
        name:"Microsoft Excel EazyComp",
        date:"28 de Junho de 2004",
        workload: 20,
        school: "EazyComp",
        imgSrcFront:MicrosoftExcelEazycomp,
        imgSrcBack: undefined
    },
    {
        id:3,
        name:"Microsoft Internet - Outlook Express EazyComp",
        date:"27 de Agosto de 2004",
        workload: 20,
        school: "EazyComp",
        imgSrcFront:MicrosoftInternetOutllokEazycomp,
        imgSrcBack: undefined
    },
    {
        id:2,
        name:"Microsoft Internet - Outlook Express EazyComp",
        date:"27 de Agosto de 2004",
        workload: 20,
        school: "EazyComp",
        imgSrcFront:MicrosoftInternetOutllokEazycomp,
        imgSrcBack: undefined
    },
    /*{
        id:26,
        name:"Curso de Dj Profissional DjBan",
        date:"10 de Julho de 2009",
        workload: 25,
        school: "DjBan",
        imgSrcFront:CursoDeDj,
        imgSrcBack: undefined
    },*/
    {
        id:1,
        name:"T&D e Marketing Pessoal",
        date:"17 de Novembro de 2009",
        workload: 5,
        school: "BeaBustos",
        imgSrcFront:MarketingPessoal,
        imgSrcBack: undefined
    },
] 